import { IconButton, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { AiFillDelete } from 'react-icons/ai';
import * as ga from '../../../canopy-ui-components/google-analytics/index';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import DeleteMenuMappingModal from './DeleteMenuMappingModal';
export function DeleteMenuMappingAction(props: {
    userId?: number[];
    data?: any[];
    globalProps?: GlobalProps;
    refreshData?: (args?: any) => void;
}) {
    const { globalProps, data } = props;
    const currentColors = useCurrentColors();
    const [showModal, setShowModal] = useState(false);
    const { t } = globalProps || {};
    const handleClick = async () => {
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Clicked Delete Menu Mapping`,
            menu: props?.data?.[0]?.description,
        });
        setShowModal(true);
    };
    return (
        <>
            <Tooltip
                aria-label="delete"
                label={t('ui.mm.tooltip.delete')}
                placement="bottom-start"
                hasArrow>
                <IconButton
                    background="transparent"
                    cursor="pointer"
                    border="none"
                    width="20px !important"
                    minWidth="20px !important"
                    height="20px !important"
                    icon={<AiFillDelete />}
                    aria-label="delete"
                    data-test="delete"
                    backgroundColor="transparent"
                    color={currentColors.brand['300']}
                    variant="ghost"
                    _hover={{
                        backgroundColor: 'transparent',
                    }}
                    _focus={{
                        border: '0px',
                        backgroundColor: 'transparent',
                        outline: 'none',
                    }}
                    _active={{
                        border: '0px',
                    }}
                    isLoading={showModal}
                    onClick={handleClick}></IconButton>
            </Tooltip>
            <DeleteMenuMappingModal
                {...props}
                showModal={showModal}
                setShowModal={setShowModal}></DeleteMenuMappingModal>
        </>
    );
}

export default DeleteMenuMappingAction;
